import React from 'react';

import { HamburgerButton } from 'components/app-header/mobile-header/hamburger-button';
import { useFeatureNavigation } from 'hooks/use-feature-navigation';

import { Wrapper } from './hamburger-button-styled';
import useHideIconOnRoute from './useHideIconOnRoute';

const DesktopHamburgerButton = () => {
  const { featureNavigationMobileHeaderButton } = useFeatureNavigation();
  const displayIconOnRoute = !useHideIconOnRoute();
  const hasNavigationLink = !!featureNavigationMobileHeaderButton?.link?.locale;

  return (
    <Wrapper hasNavigationLink={hasNavigationLink}>
      {displayIconOnRoute && <HamburgerButton />}
    </Wrapper>
  );
};
export default DesktopHamburgerButton;
